import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Public API
export const publicApi = {
  getProjects: (params) => apiClient.get('/projects', { params }),
  getProject: (id) => apiClient.get(`/projects/${id}`),
  getHeroSlides: () => apiClient.get('/hero-slides'),
  getAboutImages: () => apiClient.get('/about-images'),
  submitContact: (data) => apiClient.post('/contact', data),
  getSiteContent: () => apiClient.get('/site-content'),
  seedData: () => apiClient.post('/seed'),
};

// Admin Auth API
export const authApi = {
  login: (data) => apiClient.post('/admin/login', data),
  register: (data) => apiClient.post('/admin/register', data),
  getMe: () => apiClient.get('/admin/me'),
};

// Admin API
export const adminApi = {
  // Projects
  createProject: (data) => apiClient.post('/admin/projects', data),
  updateProject: (id, data) => apiClient.put(`/admin/projects/${id}`, data),
  deleteProject: (id) => apiClient.delete(`/admin/projects/${id}`),
  reorderProjects: (projectIds) => apiClient.put('/admin/projects/reorder', projectIds),
  
  // Image Upload
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/admin/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  // Video Upload
  uploadVideo: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/admin/upload-video', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  // Hero Slides
  getHeroSlides: () => apiClient.get('/admin/hero-slides'),
  addHeroSlide: (data) => apiClient.post('/admin/hero-slides', data),
  reorderHeroSlides: (slideIds) => apiClient.put('/admin/hero-slides/reorder', slideIds),
  deleteHeroSlide: (id) => apiClient.delete(`/admin/hero-slides/${id}`),
  
  // About Images
  getAboutImages: () => apiClient.get('/admin/about-images'),
  addAboutImage: (data) => apiClient.post('/admin/about-images', data),
  deleteAboutImage: (id) => apiClient.delete(`/admin/about-images/${id}`),
  
  // Contacts
  getContacts: () => apiClient.get('/admin/contacts'),
  markContactRead: (id) => apiClient.put(`/admin/contacts/${id}/read`),
  deleteContact: (id) => apiClient.delete(`/admin/contacts/${id}`),

  // Site Content (editable text)
  getSiteContent: () => apiClient.get('/site-content'),
  updateSiteContent: (updates) => apiClient.put('/admin/site-content', updates),
};

export default apiClient;
